module.exports = __webpack_public_path__ + "static/assets/603638405ae8edebb627fdec85eaf699.svg";